module.exports = __webpack_public_path__ + "static/media/cel_interior_bedroom-790x444.228be72f.jpg";